import { MessageBar, MessageBarType, Spinner, SpinnerSize, Icon } from '@fluentui/react';
import React, { useState, useEffect } from 'react';
import Api from '../../services/Api'

const ReleaseNotes = () => {

    const [isLoading, setLoading] = useState(false)
    const [releaseNotes, setRelaseNotes] = useState([])
    const [showGroup, setShowGroup] = useState({})
    const [message, setMessage] = useState()

    useEffect(() => {
        const fetchData = async () => {
            await getReleaseNotes();
        }
        fetchData();
    }, []);

    const getReleaseNotes = async () => {
        setLoading(true);
        try {
            const res = await Api.get('/Settings/ReleaseNotes');

            setRelaseNotes(res.data);
            if (res.data.length > 0)
                setShowGroup({[res.data[0].key]: true});

            setLoading(false);
        }
        catch(error) {
            setMessage({
                type: MessageBarType.error,
                text: 'Cannot get Release Notes settings from database: ' + error
            });
        }
    }
    
    const msg = message && 
        <MessageBar messageBarType={message.type}>
            {message.text}
        </MessageBar>

    const items = releaseNotes.map((x, index) => 
        <div key={index} style={containerStyles}>
            <div style={headerStyles} onClick={() => setShowGroup({...showGroup, [x.key]: !showGroup[x.key]})}>
                <Icon iconName={showGroup[x.key] ? 'ChevronUp' : 'ChevronDown'} style={iconStyles}/> 
                {x.key}
            </div>
            {
                showGroup[x.key] &&
                <div style={itemsStyles} dangerouslySetInnerHTML={{__html: x.value}} />
            }
        </div>    
    )
        
    return (
        <div>
            {isLoading
                ? <Spinner style={{margin: '200px'}} size={SpinnerSize.large} />
                :  
                <div className='settings-container releaseNotes-container'>
                    {items}
                    {msg}
                </div>
            }
        </div>
    );
}

const containerStyles = {
    margin: '0 20px 20px 10px',
}

const itemsStyles = {
    margin: '20px 0 0 29px',
}

const iconStyles = {
    verticalAlign: 'middle',
    marginRight: 10
}

const headerStyles = {
    fontSize: 18,
    cursor: 'pointer'
}

export default ReleaseNotes;



// WEBPACK FOOTER //
// ./src/components/Settings/ReleaseNotes.js